import Vue from 'vue';

const OnResize = new Vue();
const _ = require('lodash');

export default OnResize;

var resize = _.throttle(function (self) {
  let payload = {
    height: document.documentElement.clientHeight,
    width: document.documentElement.clientWidth,
  };
  self.$emit('resize', payload);
}, 300, { leading: true, trailing: false });

OnResize.init = function (self) {
  this.$nextTick(function () {
    window.addEventListener('resize', function (evt) {
      resize(self);
    });
  });
};
